/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
  url_im: process.env.VUE_APP_BASE_API
};
export default {
  //智能客服
  serviceRobot: {
    robotList: `${base.url_im}/serviceBusiness/conRobot/queryConRobotListPage`,
    robotAdd: `${base.url_im}/serviceBusiness/conRobot/addConRobot`,
    robotUpdate: `${base.url_im}/serviceBusiness/conRobot/updateConRobot`,
    robotDelete: `${base.url_im}/serviceBusiness/conRobot/deleteConRobot`
  },
  // 知识分类
  knowledgeCategory: {
    knowledgeCategoryListPage: `${base.url_im}/serviceBusiness/conKnowledgeCategory/queryConKnowledgeCategoryListPage`,
    knowledgeCategoryList: `${base.url_im}/serviceBusiness/conKnowledgeCategory/queryConKnowledgeCategoryList`,
    knowledgeCategoryAdd: `${base.url_im}/serviceBusiness/conKnowledgeCategory/addConKnowledgeCategory`,
    knowledgeCategoryUpdate: `${base.url_im}/serviceBusiness/conKnowledgeCategory/updateConKnowledgeCategory`,
    knowledgeCategoryDelete: `${base.url_im}/serviceBusiness/conKnowledgeCategory/deleteConKnowledgeCategory`
  },
  // 知识库
  knowledge: {
    knowledgeList: `${base.url_im}/serviceBusiness/conKnowledge/queryConKnowledgeListPage`,
    knowledgeAdd: `${base.url_im}/serviceBusiness/conKnowledge/addConKnowledge`,
    knowledgeUpdate: `${base.url_im}/serviceBusiness/conKnowledge/updateConKnowledge`,
    knowledgeDelete: `${base.url_im}/serviceBusiness/conKnowledge/deleteConKnowledge`,
    knowledgeImport: `${base.url_im}/serviceBusiness/conKnowledge/importKnowledge`,
    knowledgeExport: `${base.url_im}/serviceBusiness/conKnowledge/exportKnowledge`
  },
  //场景配置
  sceneKnowledge: {
    sceneKnowledgeList: `${base.url_im}/serviceBusiness/conSceneKnowledge/queryConSceneKnowledgeListPage`,
    sceneKnowledgeAdd: `${base.url_im}/serviceBusiness/conSceneKnowledge/addConSceneKnowledge`,
    sceneKnowledgeUpdate: `${base.url_im}/serviceBusiness/conSceneKnowledge/updateConSceneKnowledge`,
    sceneKnowledgeDelete: `${base.url_im}/serviceBusiness/conSceneKnowledge/deleteConSceneKnowledge`
  },
  //个人欢迎语
  privateWelcome: {
    privateWelcomeList: `${base.url_im}/serviceBusiness/conPrivateWelcome/queryConPrivateWelcomeListPage`,
    privateWelcomeAdd: `${base.url_im}/serviceBusiness/conPrivateWelcome/addConPrivateWelcome`,
    privateWelcomeUpdate: `${base.url_im}/serviceBusiness/conPrivateWelcome/updateConPrivateWelcome`,
    privateWelcomeDelete: `${base.url_im}/serviceBusiness/conPrivateWelcome/deleteConPrivateWelcome`
  },
  //客服常用语
  serviceWelcomeMessage: {
    importCommonMessage: `${base.url_im}/serviceBusiness/conCommonMessage/importCommonMessage`,
    importCoverCommonMessage: `${base.url_im}/serviceBusiness/conCommonMessage/importCoverCommonMessage`
  },
  //个人自动回复
  privateAutoAnswer: {
    privateAutoAnswerList: `${base.url_im}/serviceBusiness/conPrivateAutoAnswer/queryConPrivateAutoAnswerListPage`,
    privateAutoAnswerAdd: `${base.url_im}/serviceBusiness/conPrivateAutoAnswer/addConPrivateAutoAnswer`,
    privateAutoAnswerUpdate: `${base.url_im}/serviceBusiness/conPrivateAutoAnswer/updateConPrivateAutoAnswer`,
    privateAutoAnswerDelete: `${base.url_im}/serviceBusiness/conPrivateAutoAnswer/deleteConPrivateAutoAnswer`
  },
  //36拨打电话
  call:{
    customer:{
      list: `${base.url_im}/serviceBusiness/customer/list`,
      synCustomer: `${base.url_im}/serviceBusiness/customer/synCustomer`,
      getServiceUser: `${base.url}/auth/user/list`,
      setServiceUser: `${base.url_im}/serviceBusiness/customer/setServiceUser`,
      setServiceUsers: `${base.url_im}/serviceBusiness/customer/setServiceUsers`,
      export: `${base.url_im}/serviceBusiness/customer/export`,
      uploadServiceUser: `${base.url_im}/serviceBusiness/customer/uploadServiceUser`,
    },
    customercall:{
      call: `${base.url_im}/serviceBusiness/customercall/call`,
      hangupAndRecord: `${base.url_im}/serviceBusiness/customercall/hangupAndRecord`,
      edit: `${base.url_im}/serviceBusiness/customercall/edit`,
      list: `${base.url_im}/serviceBusiness/customercall/list`,
      cdrList: `${base.url_im}/serviceBusiness/customercall/cdrList`,
      cdrExport: `${base.url_im}/serviceBusiness/customercall/cdrExport`,
    },
    setting:{
      edit: `${base.url_im}/serviceBusiness/callsetting/edit`,
      list: `${base.url_im}/serviceBusiness/callsetting/list`,
      getListByUser: `${base.url_im}/serviceBusiness/callsetting/getListByUser`,
      del: `${base.url_im}/serviceBusiness/callsetting/del`,
    },
    servicedutysetting:{
      edit: `${base.url_im}/serviceBusiness/servicedutysetting/edit`,
      list: `${base.url_im}/serviceBusiness/servicedutysetting/list`,
      del: `${base.url_im}/serviceBusiness/servicedutysetting/del`,
    },
    serviceduty:{
      edit: `${base.url_im}/serviceBusiness/serviceduty/edit`,
      list: `${base.url_im}/serviceBusiness/serviceduty/list`,
      del: `${base.url_im}/serviceBusiness/serviceduty/del`,
    },
    customerTest:{
      edit: `${base.url_im}/serviceBusiness/customerTest/edit`,
      list: `${base.url_im}/serviceBusiness/customerTest/list`,
      del: `${base.url_im}/serviceBusiness/customerTest/del`,
    },
  },
  record:{
    //导出用户会话列表
    export:`${base.url_im}/serviceBusiness/bizUserAccess/exportSessionListPage`,
  }
};


